import { render, staticRenderFns } from "./SmallMap.vue?vue&type=template&id=390d3967&scoped=true"
import script from "./SmallMap.vue?vue&type=script&lang=js"
export * from "./SmallMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390d3967",
  null
  
)

export default component.exports